/**
 * Проверяет, соответствует ли строка формату "Xч Yмин Zсек".
 * @param {string} str - Проверяемая строка.
 * @returns {boolean} true, если строка соответствует формату.
 */
function checkFormatTime(str) {
  const regex = /^((\d+)\s*ч)?\s*((\d+)\s*мин)?\s*((\d+)\s*сек)?$/;
  return regex.test(str);
}

export default checkFormatTime;
